import { render } from "./StockTransferList.vue?vue&type=template&id=a95860ee&scoped=true"
import script from "./StockTransferList.vue?vue&type=script&lang=js"
export * from "./StockTransferList.vue?vue&type=script&lang=js"

import "./StockTransferList.vue?vue&type=style&index=0&id=a95860ee&scoped=true&lang=css"

import exportComponent from "D:\\DockerProjects\\armt_pos_v2_docker\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a95860ee"]])

export default __exports__